module.exports = __webpack_public_path__ + "static/media/swim.0fd30638.png";